export const PAGE_FIX_FORM_VIEW_TYPE = {
    INFO: 'info',
    OPTIONS: 'options',
    TESTING: 'testing',
} as const;
